const recommendationObjects = [
	{
		firstName:"Anna",
		nickName:"'Best Instructor'",
		lastName:"Zocher",
		img:"/assets/img/anna.jpg",
		recommendation:"Shawhien is the living embodiment of the dancing lady emoji - technically proficient, but always shows up ready to play. He uses his infectious energy not only to push himself creatively, but also to inspire and drive his teammates. Any team would be lucky to have him - if not for his strong development skills, then at least for his dad jokes."
	},
	{
		firstName:"Sarah",
		nickName:"'Mother of Lounge Lurkers'",
		lastName:"King",
		img:"/assets/img/sarah.jpg",
		recommendation:"When life gives you lemons, Shawhien will give you a pun that makes you forget how sour the lemon is. This joyous levity shone through not only in his interpersonal interactions, but also in his coding projects which are delightful demonstrations of his skill."
	},
	{
		firstName:"Nick",
		nickName:"'The Quandster'",
		lastName:"Quandt",
		img:"/assets/img/nick.jpg",
		recommendation:"I saw Shawhien wrestle a tiger once. After it had tapped out, Shawhien sat down, and bared the deep-rooted emotional problems that had led the beast to losing the battle. It's his gentle approach that enables him to tame even the most arcane bugs in a codebase, to submit and reveal their secrets. Much like the tiger."
	},
	{
		firstName:"Mads",
		nickName:"'MadsTV'",
		lastName:"Edmiston",
		img:"/assets/img/mads.jpg",
		recommendation:"Shawhien is vibrant, thoughtful, and engaged. Watching him build relationships throughout his time with General Assembly has been a joy. I am awestruck by his ability to maintain & foster budding friendships as we moved to remote modality. He is quick to offer humor & a smile whenever it is needed."
	}
]

module.exports = recommendationObjects;


// WEBPACK FOOTER //
// ./src/utils/recommendationObjects.js